(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
let searchYotpoBadge;
let searchYotpoOriginalParent;
const mountSearchYotpoBadge = () => {
  const slot = document.querySelector('.hdt-main-search .hdt-search-yotpo-slot');
  searchYotpoBadge = searchYotpoBadge || document.getElementById('y-badges');
  if (!searchYotpoBadge) return;
  searchYotpoOriginalParent = searchYotpoOriginalParent || searchYotpoBadge.parentElement;
  if (slot && window.matchMedia('(min-width: 1150px)').matches) {
    if (searchYotpoBadge.parentElement !== slot) slot.appendChild(searchYotpoBadge);
  } else if (searchYotpoOriginalParent && searchYotpoBadge.parentElement !== searchYotpoOriginalParent) {
    searchYotpoOriginalParent.appendChild(searchYotpoBadge);
  }
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountSearchYotpoBadge, { once: true });
} else {
  mountSearchYotpoBadge();
}
window.addEventListener('load', mountSearchYotpoBadge, { once: true });
window.addEventListener('resize', mountSearchYotpoBadge);
new MutationObserver(mountSearchYotpoBadge).observe(document.documentElement, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();
})();
